export default __webpack_public_path__ + "static/media/02__o_1.419247b1.jpg";